/** Shown in Settings. Bump alongside a release tag. */
export const APP_VERSION = 'v0.9.0';
